import {
  Space,
  Row,
  Col,
  Button,
  Table,
  Typography,
  Divider,
  Popover,
  message,
  Form,
} from "antd";
import React, {useEffect, useRef, useState} from "react";
import Notification from "components/common/notification/notification";
import {
  ButtonExcel,
  ColumnPopoverDisplay,
  InputFields,
  ModalCustom,
} from "components/common";
import Icons from "assets/icons";
import {ExcelSVG} from "assets";
import {inputFields as inputFieldsInit, allColumns} from "./config";
import {ColumnProps} from "types/models";
import {pharmacyStoreService} from "api";
import {FORMAT_TIME, LOAI_FORM, LOAI_PHIEU_KHO, tabKeys} from "types/enums";
import {
  getListStore,
  getListStorePhanQuyen,
  getListSupplier,
  setDetailRecord,
  setListStore,
  setSelectedRecord,
  setTypeForm,
  setTypePhieu,
} from "redux/reducer/pharmacyStore";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {setActiveKey} from "redux/reducer/common";
import {
  exportFile,
  formatDateToString,
  getTableOptions,
  randomId,
  removeObjUndefined,
  saveTableOptions,
  toNumber,
} from "helper/common";
import {RangePickerProps} from "antd/es/date-picker";
import moment from "moment";
import dayjs from "dayjs";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import ModalExport from "../ListPharmacy/ModalExport/ModalExport";
const Import = () => {
  let savedTableOption = getTableOptions(
    "IMPORT_TICKET_TABLE",
    localStorage.getItem("username")
  );
  const defaultColumns = savedTableOption
    ? allColumns.map(cl => {
        if (savedTableOption.some(it => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(it => it.dataIndex === cl.dataIndex);
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : allColumns;
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();

  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState();
  const [columns, setColumns] = useState<ColumnProps[]>(
    defaultColumns.filter(e => e.show == true)
  );
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const activeTab = useAppSelector(state => state.common.activeTab);
  const selectedRecord = useAppSelector(
    state => state.pharmacyStore.selectedRecord
  );
  const [inputFields, setInputFields] = useState(inputFieldsInit);
  const [params, setParams] = useState<any>({
    page: page,
    limit: 10,
    ["loai-phieu"]: LOAI_PHIEU_KHO.NHAP,
    start: formatDateToString(moment(), FORMAT_TIME.dayFull),
    end: formatDateToString(moment(), FORMAT_TIME.dayFull),
  });
  const listSupplier = useAppSelector(
    state => state.pharmacyStore.listSupplier
  );
  const listStore = useAppSelector(state => state.pharmacyStore.listStore);
  const setShowColumns = showColumns => {
    saveTableOptions(
      "IMPORT_TICKET_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };
  useEffect(() => {
    form.setFieldValue("start", dayjs());
    form.setFieldValue("end", dayjs());
    dispatch(getListStorePhanQuyen());
    dispatch(getListSupplier());
  }, []);
  useEffect(() => {
    if (activeTab == tabKeys.PHARMACY_STORE.IMPORT) {
      // console.log(form.setFieldValue("kho-nhap-id", "123"));
      getListImport();
      if (
        JSON.parse(localStorage.getItem("khoUserId")) &&
        form.getFieldValue("kho-nhap-id") == null
      ) {
        form.setFieldValue(
          "kho-nhap-id",
          toNumber(localStorage.getItem("khoUserId"))
        );

        setParams({
          ...params,
          ...form.getFieldsValue(),
          start: formatDateToString(
            form.getFieldValue("start"),
            FORMAT_TIME.dayFull
          ),
          end: formatDateToString(
            form.getFieldValue("end"),
            FORMAT_TIME.dayFull
          ),
          page: 1,
        });
      }
    }
  }, [activeTab]);
  useEffect(() => {
    const disabledDateStart: RangePickerProps["disabledDate"] = currentDate => {
      const endDay = form.getFieldValue("end");
      if (endDay) {
        return currentDate > endDay;
      }
    };
    const disabledDateEnd: RangePickerProps["disabledDate"] = currentDate => {
      const start = form.getFieldValue("start");
      if (start) {
        return currentDate < start;
      }
    };
    inputFieldsInit.find(e => e.name == "start").disabledDate =
      disabledDateStart;
    inputFieldsInit.find(e => e.name == "end").disabledDate = disabledDateEnd;
    setInputFields([...inputFieldsInit]);
  }, []);
  useEffect(() => {
    setOptionsStore();
  }, [listStore]);
  useEffect(() => {
    setOptionsSupplier();
  }, [listSupplier]);
  useEffect(() => {
    getListImport();
  }, [params]);
  const onChangePagination = (page, pageSize) => {
    setPage(page);
    setParams({...params, page: page, limit: pageSize});
  };
  const setOptionsStore = () => {
    const options = listStore.map(e => ({
      key: randomId(),
      value: e.id,
      label: e.name,
    }));

    inputFields.find(e => e.name == "kho-nhap-id").options = options;
    setInputFields([...inputFields]);
  };
  const setOptionsSupplier = () => {
    const options = listSupplier.map(e => ({
      key: randomId(),
      value: e.id,
      label: e.name,
    }));
    inputFields.find(e => e.name == "nhaCungCapId").options = options;

    setInputFields([...inputFields]);
  };

  const getListImport = async () => {
    setLoading(true);
    setSelectedRowKeys([]);
    try {
      const res = await pharmacyStoreService.getListReceipt(params);
      const data = res.data.map(e => ({...e, key: e.id}));
      setLoading(false);
      setTotal(res.total);
      setData(data);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi khi lấy danh sách phiếu");
    }
  };

  const onClickSearch = () => {
    const formValue = form.getFieldsValue();
    let searchFields = {
      ...formValue,
      start: formatDateToString(formValue.start, FORMAT_TIME.dayFull) ?? null,
      end: formatDateToString(formValue.end, FORMAT_TIME.dayFull) ?? null,
    };
    // searchFields = removeObjUndefined(searchFields);
    setParams({...params, ...searchFields, page: 1});
    setPage(1);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setSelectedRowKeys(selectedRowKeys);
      dispatch(setSelectedRecord(selectedRows[0]));
    },
  };
  const navigateTab = () => [
    dispatch(setActiveKey(tabKeys.PHARMACY_STORE.DETAIL)),
  ];
  const createPhieu = () => {
    dispatch(setTypeForm(LOAI_FORM.TAO_MOI));
    dispatch(setTypePhieu(LOAI_PHIEU_KHO.NHAP));
    dispatch(setDetailRecord(null));
    navigateTab();
  };
  const viewDeTailPhieu = () => {
    if (selectedRecord?.loaiPhieu == LOAI_PHIEU_KHO.NHAP) {
      dispatch(setTypeForm(LOAI_FORM.DA_TAO));
      dispatch(setTypePhieu(LOAI_PHIEU_KHO.NHAP));
      navigateTab();
    } else {
      Notification("warning", "Chưa chọn phiếu nhập");
    }
  };
  const getReport = async () => {
    const data = {
      start: params?.start,
      end: params?.end,
      khoId: params?.["kho-nhap-id"],
      loaiPhieu: LOAI_PHIEU_KHO.NHAP,
      nhomPhieu: "TH",
      status: params?.["tinh-trang"],
    };
    if (data?.khoId == null) {
      Notification("warning", "Chưa chọn kho");
    } else if (!data?.start) {
      Notification("warning", "Chưa chọn ngày tạo từ");
    } else if (!data?.end) {
      Notification("warning", "Chưa chọn ngày tạo đến");
    } else {
      const nameFile = `Báo cáo xuất nhập kho ${data?.start} - ${data?.end}`;
      exportFile("store/receipt/export-thong-ke-nhap-xuat-kho", data, nameFile);
    }
  };
  const onKeyDown = e => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };
  return (
    <div className="import" onKeyDown={onKeyDown} tabIndex={0}>
      <div className="container">
        <Form form={form}>
          <Row gutter={[16, 8]}>
            {inputFields && <InputFields data={inputFields} />}
          </Row>
          <Row justify={"end"} style={{marginTop: 8}}>
            <Space>
              <Button
                className="btn-sub"
                icon={<Icons.reload />}
                onClick={() => {
                  form.resetFields();
                  onClickSearch();
                }}
              >
                Xoá tìm kiếm
              </Button>
              <Button
                icon={<Icons.search />}
                type="primary"
                onClick={onClickSearch}
              >
                Tìm kiếm
              </Button>
            </Space>
          </Row>
        </Form>
      </div>
      <div className="container">
        <Space style={{width: "100%"}} direction="vertical">
          <Typography.Text strong>Danh sách phiếu nhập</Typography.Text>
          <Divider type="horizontal" style={{margin: "0"}} />
          <Row justify={"space-between"} gutter={[16, 8]}>
            <Col>
              <Space>
                <ButtonExcel onClick={getReport}></ButtonExcel>
              </Space>
            </Col>
            <Col>
              <Space style={{width: "100%"}}>
                <Popover
                  trigger="click"
                  placement="topLeft"
                  content={
                    <ColumnPopoverDisplay
                      setShowColumns={setShowColumns}
                      columns={defaultColumns}
                    ></ColumnPopoverDisplay>
                  }
                >
                  <Button icon={<Icons.bars />} className="btn-sub">
                    Cột hiển thị
                  </Button>
                </Popover>

                <Button
                  icon={<Icons.file />}
                  className="btn-sub"
                  onClick={() => {
                    createPhieu();
                  }}
                >
                  Tạo phiếu
                </Button>
                <Button
                  icon={<Icons.file />}
                  className="btn-sub"
                  onClick={() => {
                    viewDeTailPhieu();
                  }}
                >
                  Chi tiết phiếu
                </Button>
              </Space>
            </Col>
          </Row>
          <CustomResizableTable
            setShowColumns={setShowColumns}
            loading={loading}
            // className="custom-resize-table-scroll"
            columns={columns}
            dataSource={data}
            pagination={{
              position: ["bottomRight"],
              showSizeChanger: true,
              current: page,
              total: total,
              onChange: onChangePagination,
            }}
            rowSelection={{
              type: "radio",
              ...rowSelection,
            }}
            bordered={true}
            onRow={(record, rowIndex) => {
              return {
                onDoubleClick: event => {
                  dispatch(setSelectedRecord(record));
                  dispatch(setTypeForm(LOAI_FORM.DA_TAO));
                  dispatch(setTypePhieu(LOAI_PHIEU_KHO.NHAP));
                  navigateTab();
                }, // double click row
              };
            }}
            scroll={{x: "auto"}}
          />
        </Space>
      </div>
    </div>
  );
};

export default Import;
